import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import withReduxForm from 'barnyard/components/Input/withReduxForm';
import BaseInput from 'barnyard/components/Input/BaseInput';
import { Row, Col } from 'barnyard/layouts';
import { AnimalIcon } from 'barnyard/icons';

const classNamePrefix = 'Signup--SpeciesSelect';

function speciesLookup(speciesKind) {
  return speciesKind.toLowerCase();
}


class SpeciesSelect extends Component {
  onClick(speciesValue) {
    const {
      value,
      onChange
    } = this.props;

    if (this.isSelected(speciesValue)) {
      return onChange(_.filter(value, v => v !== speciesValue));
    }

    return onChange([...value, speciesValue]);
  }

  isSelected(speciesValue) {
    const {
      value
    } = this.props;

    if (!value) {
      return false;
    }

    return _.includes(value, speciesValue);
  }

  render() {
    const {
      speciesTypes,
      tip,
      label,
      error
    } = this.props;

    return (
      <BaseInput
        label={label}
        tip={tip}
        error={error}
      >
        <Row className={classNamePrefix} align='middle' justify='spaces' gutter='md'>
          {
            _.map(
              speciesTypes,
              (sName, sKind) => (
                <Col
                  key={sKind}
                  md='full'
                  xs={6}
                  onClick={() => this.onClick(sKind)}
                >
                  <div
                    className={cx({
                      [`${classNamePrefix}__type`]: true,
                      [`${classNamePrefix}__type__${speciesLookup(sKind)}`]: true,
                      selected: this.isSelected(sKind)
                    })}
                  >
                    <AnimalIcon animal={speciesLookup(sKind)} />
                    <div className={`${classNamePrefix}__type__name`}>
                      <h4>{sName}</h4>
                    </div>
                  </div>
                </Col>
              )
            )
          }
        </Row>
      </BaseInput>
    );
  }
}

SpeciesSelect.defaultProps = {
  value: []
};

SpeciesSelect.propTypes = {
  speciesTypes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
  tip: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default withReduxForm(SpeciesSelect);

